<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.d-inline-block
    //- Button Add
    .text-right(v-if="mode === 'add'")
        button.btn.btn-primary(@click="showModal = true")
            font-awesome-icon(icon="plus")
            span.d-none.d-sm-inline.ml-2 Raum hinzufügen
    //- Button Edit
    button.btn.btn-sm.btn-secondary.mb-2.mr-2(v-else, @click="showModal = true")
        font-awesome-icon(icon="pen")
        span.d-none.d-sm-inline.ml-2 bearbeiten

    //- Modal
    .modal-backdrop.fade.show(v-if="showModal")
    .modal(:class="{ 'd-block': showModal }")
        .modal-dialog.modal-dialog-scrollable.modal-md
            form.modal-content(@submit.prevent="addAndClose")
                header.modal-header
                    h5.modal-title(v-if="mode === 'add'") Raum hinzufügen
                    h5.modal-title(v-else) Raum bearbeiten
                    button.close(type="button", @click="showModal = false") &times;

                .modal-body
                    //- Name/Nutzung Formgroup
                    .form-group.mb-4
                        label.label-title Nutzung:
                        select.custom-select(v-model="room.name", required)
                            option(disabled) Bitte auswählen
                            option(:value="r.value", v-for="r in roomNames") {{ r.text }}

                    //- Volume Formgroup
                    .form-group.mb-5
                        label.label-title Raumvolumen (m³):
                        numeric-input(v-model.number="room.volume", allowMath=true, required)

                    //- VLR Formgroup
                    .form-group.mb-5
                        label.label-title Handelt es sich um einen Verbrennungsluftraum?
                        help-text-modal(:body="$t('modals.room.vlr.helptext')")
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_vlr1`",
                                type="radio",
                                v-model="room.isVlr",
                                :value="true"
                            )
                            label.custom-control-label(:for="`${_uid}_vlr1`") ja, es ist ein Verbrennungsluftraum
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_vlr0`",
                                type="radio",
                                v-model="room.isVlr",
                                :value="false"
                            )
                            label.custom-control-label(:for="`${_uid}_vlr0`") nein, es ist keiner

                    //- Doortype Formgroup
                    .form-group.mb-4(v-if="room.isVlr")
                        label.label-title Welche Eigenschaften hat die Innentür?
                        help-text-modal(:body="$t('modals.room.doortype.helptext')")
                        select.custom-select(v-model="room.doorType")
                            option(:value="undefined", disabled) Keine Eigenschaft definiert
                            option(:value="d.value", v-for="d in doorTypes") {{ d.text }}
                        small.form-text.text-muted Gemeint ist immer die Tür zum Aufstellraum hin

                    //- Description Formgroup
                    character-count-textarea(v-model="room.description")

                footer.modal-footer
                    button.btn.btn-secondary(type="button", @click="showModal = false") Abbrechen
                    button.btn.btn-primary(v-if="mode === 'add'", type="submit") Raum hinzufügen
                    button.btn.btn-primary(v-else, type="submit") Raum speichern
</template>

<script>
import { doorTypes, roomNames } from '@/constants'
import { Room } from 'trgi'
import CharacterCountTextarea from '@/components/CharacterCountTextarea'
import HelpTextModal from '@/components/HelpTextModal'
import NumericInput from '@/components/NumericInput'

export default {
    components: {
        CharacterCountTextarea,
        HelpTextModal,
        NumericInput
    },
    props: {
        value: {
            type: Room,
            required: false,
            default: function () {
                return new Room()
            }
        }
    },
    data () {
        const room = new Room(this.value)
        return {
            room,
            mode: this.value.name ? 'edit' : 'add',
            showModal: false,
            doorTypes,
            roomNames
        }
    },
    watch: {
        // When Room gets modified (e.g. Fireplace Modal), refresh Local Room Variable
        value (value) {
            this.room = new Room(value)
        }
    },
    methods: {
        addAndClose () {
            this.$emit('input', this.room)
            this.showModal = false

            // Reset Room after Changes are populated
            this.$nextTick(function () {
                this.room = new Room(this.value)
            })
        }
    }
}
</script>
